import * as types from "../types/foodSpecificationsMap"

const initialState = {}

const foodSpecificationsMapReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FOOD_SPECIFICATIONS: {
      const newSpecificationMap = {}

      action.specifications.forEach(specification => {
        newSpecificationMap[specification._id] = specification
      })

      const newState = {
        ...state,
        ...newSpecificationMap
      }

      return newState
    }
    case types.UPDATE_FOOD_SPECIFICATIONS: {
      const newState = { ...state }

      action.specifications.forEach(specification => {
        newState[specification._id] = specification
      })

      return newState
    }
    case types.DELETE_FOOD_SPECIFICATIONS:
      const newState = { ...state }

      action.specificationIds.forEach(specificationId => {
        delete newState[specificationId]
      })

      return newState
    case types.CLEAR_FOOD_SPECIFICATIONS:
      return {}
    default:
      return state
  }
}

export default foodSpecificationsMapReducer